import React, { useState } from 'react';
import { DropdownToggle, DropdownMenu, Dropdown } from 'reactstrap';
import { LinkList } from 'src/components/links/Links';
import { logout } from 'src/actions/accountActions';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';

import domain from 'src/config/domain';
import {
  AdjustmentsHorizontalIcon,
  UserCircleIcon,
  CursorArrowRippleIcon,
  ArrowLeftOnRectangleIcon,
  UserIcon,
} from '@heroicons/react/24/outline';

const User = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen((prevState) => !prevState);

  const dispatch = useDispatch();
  const history = useHistory();
  const account = useSelector((state) => state.account);
  const domainConfig = domain();

  const handleSignout = async (e) => {
    e.preventDefault();
    await dispatch(logout());

    setTimeout(() =>{
      history.push("/");
    }, 1500);
  };

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        id="button_user_toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserCircleIcon className={`h-9 w-9 ${domainConfig.styles.textColour}`} />
        </div>
      </DropdownToggle>
      <DropdownMenu end className="dropdown-menu-md dropdown-menu-s1">
        <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
          <div className="user-card sm">
            <div className="user-avatar">
              <span>{ account.account.first_name.charAt(0) }{ account.account.last_name.charAt(0) }</span>
            </div>
            <div className="user-info">
              <span className="lead-text">{ account.account.first_name } { account.account.last_name }</span>
              <span className="sub-text">{ account.user.attributes.email }</span>
            </div>
          </div>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <Link to="/user/profile" onClick={toggle}>
              <UserIcon className="h-5 w-5 mr-2" />
              Profile
            </Link>
            <Link to="/user/setting" onClick={toggle}>
              <AdjustmentsHorizontalIcon className="h-5 w-5 mr-2" />
              Account Settings
            </Link>
            <Link to="/user/activity" onClick={toggle}>
              <CursorArrowRippleIcon className="h-5 w-5 mr-2" />
              User Activity
            </Link>
          </LinkList>
        </div>
        <div className="dropdown-inner">
          <LinkList>
            <a href={`/`} onClick={handleSignout} id="sign-out-button">
              <ArrowLeftOnRectangleIcon className="h-5 w-5 mr-2" />
              <span>Sign Out</span>
            </a>
          </LinkList>
        </div>
      </DropdownMenu>
    </Dropdown>
  );
};

export default User;

